const BlankTemplate = (props) => {
    return props.children;
};
    
export default BlankTemplate;